const Blowfish = require("javascript-blowfish");

export default class Encryption {
    #bf

    constructor() {
        const key = process.env.VUE_APP_CONFIG_CRYPT_KEY;

        if (isConstructor(Blowfish)) {
            this.#bf = new Blowfish(key, "ecb");
        } else {
            this.#bf = new Blowfish.Blowfish(key, "ecb");
        }

        function isConstructor(f) {
            try {
                new f("key");
            } catch (err) {
            // verify err is the expected error and then
                return false;
            }
            return true;
        }
    }

    encrypt(value) {
        let encryptedString = this.#bf.encrypt(JSON.stringify(value));

        encryptedString = this.#bf.base64Encode(encryptedString);
        return encryptedString;
    }

    decrypt(value) {
        var decryptedString = this.#bf.base64Decode(value);
        decryptedString = this.#bf.decrypt(decryptedString);
        decryptedString = this.#bf.trimZeros(decryptedString).replace(/[^A-Za-zà-úÀ-Ú 0-9 .,?""!@#$%^&*()-_=+;:<>/|}{[]`~]*/g, '');
        return decryptedString;
    }
}